import { schema } from "normalizr";
import { UserRecord as Record } from "records/user";

export const UserSchema = new schema.Entity(
    "user",
    {},
    {
        idAttribute: "_id",
    }
);

(UserSchema as any).record = Record;
